import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://mixbwafiqikyhsbyhqye.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1peGJ3YWZpcWlreWhzYnlocXllIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc4ODUyNTYsImV4cCI6MjA5MzQ2MTI1Nn0.4WxuyvlxIt_RtqFIBW9f8WF4StdgFn6h_yZ5uM7ei70';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

// Yazma işlemlerinden önce çağrılır: oturum yoksa null döner, süresi dolmak üzereyse yeniler.
// Sekme uzun süre arka planda kaldığında otomatik yenileme gecikebildiği için gerekli.
export async function ensureSession() {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) return null;
  const msLeft = (session.expires_at || 0) * 1000 - Date.now();
  if (msLeft > 120000) return session;
  const { data, error } = await supabase.auth.refreshSession();
  if (error || !data.session) return null;
  return data.session;
}
